import { css } from 'styled-components';

import RighteousRegular from '../../assets/fonts/Righteous-Regular.ttf';
import MonserratBlack from '../../assets/fonts/Montserrat-Black.ttf';
import MonserratRegular from '../../assets/fonts/Montserrat-Regular.ttf';

export default css`
  @font-face {
    font-family: 'Righteous';
    src: url(${RighteousRegular}) format('truetype');
    font-weight: 400;
    font-style: 'normal';
  }

  @font-face {
    font-family: 'MontserratBlack';
    src: url(${MonserratBlack}) format('truetype');
    font-weight: 400;
    font-style: 'normal';
  }

  @font-face {
    font-family: 'MontserratRegular';
    src: url(${MonserratRegular}) format('truetype');
    font-weight: 400;
    font-style: 'normal';
  }
`;
